<template>
	<v-dialog
		v-model="showDialog"
		max-width="800"
		persistent
		v-if="selectedTemplate && init"
	>
		<v-card>
			<v-card-title> Template Fields </v-card-title>
			<v-card-text>
				<v-text-field v-model="id"
							  ref="Id"
							  :rules="rules.required"
							  class="d-none"
							  hide-details="auto"
							  label="Id" />
				<v-row>
					<v-col cols="7">
						<v-text-field v-model="label"
									  ref="Label"
									  :rules="rules.required"
									  hide-details="auto"
									  label="Spreadsheet Field Label"
									  @keydown.enter="onSave" />
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn-toggle v-model="dataFieldType"
									  class="d-flex"
									  color="primary"
									  group
									  mandatory>
							<v-btn :value="1" class="flex-grow-1">
								<v-icon>mdi-table</v-icon>
								Table Field
							</v-btn>
							<v-btn :value="2" class="flex-grow-1">
								<v-icon>mdi-link-variant</v-icon>
								Link Field
							</v-btn>
							<v-btn :value="3" class="flex-grow-1">
								<v-icon>mdi-form-dropdown</v-icon>
								Reference Field
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<v-row v-if="isReferenceField">
					<v-col>
						<v-autocomplete v-if="isReferenceField"
										v-model="referenceTypeId"
										ref="ReferenceTypeId"
										:items="referenceTypes"
										:rules="rules.required"
										item-text="Name"
										item-value="Id"
										label="Reference List" />
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-autocomplete v-model="dataFieldId"
										ref="DataFieldId"
										:allow-overflow="false"
										:items="availableDataFields"
										:rules="rules.required"
										hide-selected
										item-text="FieldName"
										:filter="customFilter"
										item-value="Id"
										:label="isReferenceField ? 'Link Field' : 'Iris Field'">
							<template v-slot:selection="data">
								{{ data.item.EntityName }} -
								{{ data.item.FieldName }}
								<span v-if="data.item.GvfLabel">
									&nbsp; ({{ data.item.GvfLabel }})
								</span>
							</template>
							<template v-slot:item="data">
								<template v-if="isObject(data.item)">
									<v-list-item-content>
										{{
										data.header
										}}
									</v-list-item-content>
								</template>
								<template v-else>
									<v-list-item-content>
										<v-list-item-title>
											{{ data.item.FieldName }}
											<span v-if="data.item.GvfLabel">
												({{ data.item.GvfLabel }})
											</span>
										</v-list-item-title>
										<v-list-item-subtitle>
											{{
											data.item.EntityName
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
				<v-row v-if="isLinkField">
					<v-col>
						<v-autocomplete v-if="isLinkField"
										v-model="linkFieldId"
										ref="LinkFieldId"
										:items="linkFields"
										:rules="rules.required"
										item-text="Label"
										item-value="Id"
										label="Link Field"
										:filter="customFilter">
							<template v-slot:selection="data">
								{{ data.item.EntityName }} -
								{{ data.item.FieldName }}
								<span v-if="data.item.GvfLabel">
									&nbsp; ({{ data.item.GvfLabel }})
								</span>
							</template>
							<template v-slot:item="data">
								<template v-if="isObject(data.item)">
									<v-list-item-content>
										{{
									data.header
										}}
									</v-list-item-content>
								</template>
								<template v-else>
									<v-list-item-content>
										<v-list-item-title>
											{{ data.item.FieldName }}
											<span v-if="data.item.GvfLabel">
												({{ data.item.GvfLabel }})
											</span>
										</v-list-item-title>
										<v-list-item-subtitle>
											{{
										data.item.EntityName
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-switch v-model="isMergeField"
								  color="primary"
								  label="Merge field">
						</v-switch>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { TemplateGetters } from '../../../store/getters';
import { FieldDataTypes } from '@/enums/fieldDataTypes';
import { TemplateActions } from '../../../store/actions';

export default {
	name: 'TemplateFieldModal',
	props: {
		showDialog: Boolean,
		selectedTemplate: Object,
		editField: Object,
	},
	data() {
		return {
			init: false,
			dataFieldType: 1,
			id: -1,
			label: '',
			dataFieldId: null,
			linkFieldId: null,
			referenceTypeId: null,
			isMergeField: false,
			order: null,
			rules: {
				required: [(value) => !!value || 'Field is required'],
			},
		};
	},
	computed: {
		entity() {
			if (!this.selectedTemplate) return null;
			if (!this.selectedTemplate.EntityId) return null;
			if (!this.entities) return null;
			let result = this.entities.find(
				(x) => x.Id == this.selectedTemplate.EntityId
			);
			return result;
		},
		...mapGetters({
			entities: [TemplateGetters.ENTITIES],
			gridViews: [TemplateGetters.GET_GRID_VIEWS],
			dataFields: [TemplateGetters.GET_DATA_FIELDS],
			referenceTypes: [TemplateGetters.GET_REFERENCE_LIST_TYPES],
			templateFields: [TemplateGetters.TEMPLATE_FIELDS],
			//otherEntitiesGridViewFields:[TemplateGetters.GET_LINK_FIELD_DATA_FIELDS],
		}),

		currentGridViewFields() {
			if (!this.templateFields) return [];
			if (this.templateFields.length <= 0) return [];
			let result = this.templateFields
				.filter((x) => x.GridViewField)
				.map((x) => x.GridViewField);
			return result;
		},
		otherEntitiesGridViewFields() {
			if (!this.gridViews) return [];
			if (!this.entity) return [];
			let otherGridViews = this.gridViews.filter(
				(x) => x.EntityId != this.entity.Id
			);
			let gvf = [];
			otherGridViews.forEach((gv) => {
				if (gv.Columns) {
					gvf = [...gvf, ...gv.Columns];
				}
			});
			return gvf;
		},

		availableDataFields() {
			switch (this.dataFieldType) {
				case 2: {
					let result = [];
					result = this.otherEntitiesGridViewFields
						.map((x) => ({ GvfLabel: x.GvfLabel, ...x.DataField }))
						.sort((a, b) => (a.FieldName > b.FieldName ? 1 : -1));
					return result;
				}
				case 3:
					return this.dataFields
						.filter(
							(x) =>
								x.DataType ===
									FieldDataTypes.UNIQUE_IDENTIFIER &&
								x.EntityId === this.entity.Id
						)
						.sort((a, b) => (a.FieldName > b.FieldName ? 1 : -1));
				default: {
					let usedDataFieldsIds =
						this.currentGridViewFields &&
						this.currentGridViewFields.length > 0
							? this.currentGridViewFields.map(
									(x) => x.DataFieldId
							  )
							: [];

					if (
						this.editField &&
						this.editField.GridViewField &&
						this.editField.GridViewField.DataFieldId
					) {
						let index = usedDataFieldsIds.indexOf(
							this.editField.GridViewField.DataFieldId
						);
						if (index > -1) {
							usedDataFieldsIds.splice(index, 1);
						}
					}
					return this.dataFields
						.filter((x) => {
							return (
								x.EntityId === this.entity.Id &&
								usedDataFieldsIds.indexOf(x.Id) === -1
							);
						})
						.sort((a, b) => (a.FieldName > b.FieldName ? 1 : -1));
				}
			}
		},

		linkFields() {
			if (!this.entity) return [];
			if (this.dataFieldType === 2) {
				return this.dataFields
					.filter(
						(x) =>
							x.DataType === FieldDataTypes.UNIQUE_IDENTIFIER &&
							x.EntityId === this.entity.Id
					)
					.sort((a, b) => (a.FieldName > b.FieldName ? 1 : -1));
			}
			return [];
		},
		isLinkField() {
			return this.dataFieldType === 2;
		},
		isReferenceField() {
			return this.dataFieldType === 3;
		},
	},
	destroyed() {
		this.$store.dispatch(TemplateActions.CLEAR_TEMPLATE_FIELD_MODAL);
	},
	mounted() {
		this.$store
			.dispatch(TemplateActions.LOAD_TEMPLATE_FIELD_MODAL)
			.then(() => {
				this.init = true;
			});

		if (this.editField) {
			this.label = this.editField.Label;
			this.isMergeField = this.editField.IsMergeField;
			if (this.editField.Order) {
				this.order = this.editField.Order;
			}

			if (this.editField.GridViewField) {
				this.dataFieldType = this.editField.GridViewField
					.ReferenceListTypeId
					? 3
					: this.editField.GridViewField.LinkFieldId
					? 2
					: 1;
				this.dataFieldId = this.editField.GridViewField.DataFieldId;
				this.linkFieldId = this.editField.GridViewField.LinkFieldId;
				this.referenceTypeId =
					this.editField.GridViewField.ReferenceListTypeId;
				if (!this.order)
					this.order = this.editField.GridViewField.Order;
			}
		}
	},
	watch: {
		dataFieldType() {
			if (this.editField && !this.editField.Id) {
				this.dataFieldId = null;
				this.linkFieldId = null;
				this.referenceTypeId = null;
			}
		},
	},
	methods: {
		customFilter(item, queryText) {
			if (item.FieldName)
				if (
					item.FieldName.toLowerCase().includes(
						queryText.toLowerCase()
					)
				)
					return item;
			if (item.GvfLabel)
				if (
					item.GvfLabel.toLowerCase().includes(
						queryText.toLowerCase()
					)
				)
					return item;
		},
		validate() {
			let formHasErrors = false;
			let formFields = {
				Label: this.label,
				DataFieldId: this.dataFieldId,
			};

			if (this.dataFieldType === 2) {
				formFields.LinkFieldId = this.linkFieldId;
			}
			if (this.dataFieldType === 3) {
				formFields.ReferenceTypeId = this.referenceTypeId;
			}

			Object.keys(formFields).forEach((index) => {
				if (!formFields[index]) formHasErrors = true;
				this.$refs[index].validate(true);
			});
			return !formHasErrors;
		},
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.validate()) return;

			let payload = {};
			if (this.editField) {
				payload = JSON.parse(JSON.stringify(this.editField));
			}

			payload.Confirmed = true;
			payload.Label = this.label;
			payload.IsMergeField = this.isMergeField;
			if (this.order) {
				payload.order = this.order;
			} else {
				payload.order = this.templateFields.length + 1;
			}

			payload.GridViewId = this.selectedTemplate.Id;
			if (!payload.GridViewField) payload.GridViewField = {};
			if (this.order) {
				payload.GridViewField.Order = this.order;
			} else {
				payload.GridViewField.Order =
					this.currentGridViewFields.length + 1;
			}

			payload.GridViewField.Label = this.label;
			(payload.GridViewField.DataFieldId = this.dataFieldId),
				(payload.GridViewField.LinkFieldId =
					this.dataFieldType === 2 ? this.linkFieldId : null),
				(payload.GridViewField.ReferenceListTypeId =
					this.dataFieldType === 3 ? this.referenceTypeId : null),
				(payload.GridViewField.GridViewId = this.selectedTemplate.Id);
			payload.GridViewField.IsVisible = true;
			payload.GridViewField.IsVisibleEditForm = true;

			if (payload.Id) {
				this.$store
					.dispatch(TemplateActions.UPDATE_TEMPLATE_FIELD, payload)
					.then((success) => {
						if (!success) return;
						this.$emit('close');
					});
			} else {
				this.$store
					.dispatch(TemplateActions.ADD_TEMPLATE_FIELD, payload)
					.then((success) => {
						if (!success) return;
						this.$emit('close');
					});
			}
		},

		isObject(item) {
			return typeof item !== 'object';
		},
	},
};
</script>

<style scoped>
.row + .row {
	margin-top: 0;
}

.v-input--selection-controls {
	margin-top: 0;
	padding-top: 0;
}

.v-text-field {
	margin-top: 0;
	padding-top: 0;
}
</style>
